import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF", width = "8", height = "13" }) => {
  return (
    <svg
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4564 8.06872L6.8188 3.43117L2.18124 8.06873L0.75 6.63753L6.8188 0.56873L12.8876 6.63753L11.4564 8.06872Z"
        fill="#848E98"
      />
    </svg>
  );
};

export default memo(Icon);
